// extracted by mini-css-extract-plugin
export default {"ParentIssueTokenContainer":"parent-issue-token-module__ParentIssueTokenContainer--JWULP","ParentIssueTokenMain":"parent-issue-token-module__ParentIssueTokenMain--tVwdW"};